import type { NextPage, GetServerSideProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

import PlansPage from 'src/features2/plans/ui/components/PlansPage';
import Script from 'next/script';
import React from 'react';

const PricingPage: NextPage = () => {
  const planData = {
    selectPlan: () => {},
    isProcessing: false,
  };

  // iframeResizer script is used to dynamically adjust iframe height considering its content
  return (
    <>
      <style>{'#__next {height: auto;}'}</style>
      <Script
        src="https://cdnjs.cloudflare.com/ajax/libs/iframe-resizer/4.3.6/iframeResizer.contentWindow.min.js"
        integrity="sha512-R7Piufj0/o6jG9ZKrAvS2dblFr2kkuG4XVQwStX+/4P+KwOLUXn2DXy0l1AJDxxqGhkM/FJllZHG2PKOAheYzg=="
        crossOrigin="anonymous"
        referrerPolicy="no-referrer"
      />
      <PlansPage
        isStandalonePage
        isUserOnFreePlan={false}
        isUserOnFreeTrial={false}
        isFreeTrialEnded={false}
        freeTrialDayLeft={10}
        selectPlan={() => {}}
        planData={planData}
      />
    </>
  );
};

export const getServerSideProps: GetServerSideProps = async ({ locale = 'en' }) => ({
  props: {
    ...(await serverSideTranslations(locale, ['common', 'billing', 'plans'])),
  },
});

export default PricingPage;
